(function () {
  var TRUSTED_SHOPS_REVIEWS_URLS = {
    at: 'https://www.trustedshops.at/bewertung/info_X91B723F086031C6867652181B423033A.html',
    de: 'https://www.trustedshops.de/bewertung/info_X264FE84D74CA8B30806C582EA2BBA6F9.html',
  };

  // Hide expand arrow + individual review content inside Trusted Shops shadow roots
  var HIDE_REVIEWS_CSS =
    '.arrow-icon,' +
    'img.arrow-icon,' +
    '.show-reviews .arrow-icon,' +
    'trstd-selected-reviews-section,' +
    'trstd-review-card,' +
    '.review-cards,' +
    '.reviews-detail,' +
    '#welcome-reviews-detail,' +
    '[id*="reviews-detail"],' +
    '[class*="review-card"]{' +
    'display:none!important;' +
    'visibility:hidden!important;' +
    'height:0!important;' +
    'max-height:0!important;' +
    'overflow:hidden!important;' +
    'margin:0!important;' +
    'padding:0!important;' +
    '}';

  var HIDE_SELECTOR =
    '.arrow-icon, img.arrow-icon, trstd-selected-reviews-section, trstd-review-card, .review-cards, .reviews-detail, #welcome-reviews-detail';

  var FLOATING_REVIEWS_SELECTOR =
    '[data-testid="trustbadge-reviews-content-box"], [id^="contentBoxWithLink_reviews-"]';

  var observedRoots = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function getTrustedShopsReviewsUrl() {
    if (window.trustedShopsReviewsUrl) return window.trustedShopsReviewsUrl;
    if (window.location.hostname.indexOf('kijimea.at') !== -1) return TRUSTED_SHOPS_REVIEWS_URLS.at;
    return TRUSTED_SHOPS_REVIEWS_URLS.de;
  }

  function openTrustedShopsReviews() {
    window.open(getTrustedShopsReviewsUrl(), '_blank', 'noopener,noreferrer');
  }

  function isElement(node) {
    return node && node.nodeType === 1;
  }

  function isFloatingReviewsBox(node) {
    if (!isElement(node)) return false;
    if (node.matches && node.matches(FLOATING_REVIEWS_SELECTOR)) return true;
    return typeof node.id === 'string' && node.id.indexOf('contentBoxWithLink_reviews-') === 0;
  }

  function getVisibleText(node) {
    if (!isElement(node)) return '';
    return (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isShowReviewsControl(node) {
    if (!isElement(node)) return false;
    if (node.classList && node.classList.contains('show-reviews')) return true;
    if (node.matches && node.matches('.show-reviews, .show-reviews-text')) return true;

    var text = getVisibleText(node);
    if (text.indexOf('bewertungen anzeigen') !== -1) return true;

    var label = (
      (node.getAttribute && (node.getAttribute('aria-label') || node.getAttribute('title'))) ||
      ''
    )
      .toLowerCase()
      .trim();
    return label.indexOf('bewertungen anzeigen') !== -1;
  }

  function shouldRedirectToTrustedShops(path) {
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (isFloatingReviewsBox(node) || isShowReviewsControl(node)) return true;
    }
    return false;
  }

  function handleTrustedShopsEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    if (!shouldRedirectToTrustedShops(path)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openTrustedShopsReviews();
  }

  function injectHideReviewsStyles(root) {
    if (!root) return;

    var existing = root.querySelector && root.querySelector('style[data-kijimea-hide-ts-reviews]');
    if (existing) return;

    var style = document.createElement('style');
    style.setAttribute('data-kijimea-hide-ts-reviews', 'true');
    style.textContent = HIDE_REVIEWS_CSS;
    (root.head || root).appendChild(style);
  }

  function hideElement(element) {
    if (!element || !element.style) return;
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('height', '0', 'important');
    element.style.setProperty('max-height', '0', 'important');
    element.style.setProperty('overflow', 'hidden', 'important');
    element.setAttribute('aria-hidden', 'true');
  }

  function querySelectorAllDeep(selector, root) {
    root = root || document;
    var results = [];

    if (root.querySelectorAll) {
      results = results.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    Array.prototype.forEach.call(elements, function (element) {
      if (!element.shadowRoot) return;
      results = results.concat(querySelectorAllDeep(selector, element.shadowRoot));
    });

    return results;
  }

  function walkShadowRoots(root, callback) {
    root = root || document;
    callback(root);

    var elements = root.querySelectorAll ? root.querySelectorAll('*') : [];
    Array.prototype.forEach.call(elements, function (element) {
      if (!element.shadowRoot) return;
      walkShadowRoots(element.shadowRoot, callback);
    });
  }

  function observeRoot(root) {
    if (!root) return;
    if (observedRoots) {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
    } else if (root.__kijimeaTsObserved) {
      return;
    } else {
      root.__kijimeaTsObserved = true;
    }

    var observer = new MutationObserver(function () {
      scan();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function hideIndividualReviewsEverywhere() {
    walkShadowRoots(document, function (root) {
      injectHideReviewsStyles(root);
      observeRoot(root);
    });

    querySelectorAllDeep(HIDE_SELECTOR).forEach(hideElement);
  }

  function configureFloatingReviewsBox(element) {
    if (!element || element.dataset.tsReviewsLinked === 'true') return;
    element.dataset.tsReviewsLinked = 'true';
    element.style.cursor = 'pointer';
  }

  function scan() {
    hideIndividualReviewsEverywhere();
    querySelectorAllDeep(FLOATING_REVIEWS_SELECTOR).forEach(configureFloatingReviewsBox);
  }

  document.addEventListener('click', handleTrustedShopsEvent, true);
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      handleTrustedShopsEvent(event);
    },
    true
  );

  scan();
  // Widget loads late – keep scanning briefly after boot
  var retries = 0;
  var bootInterval = setInterval(function () {
    scan();
    retries += 1;
    if (retries >= 40) clearInterval(bootInterval);
  }, 500);
})();
